
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Link from '@tiptap/extension-link';
import Image from '@tiptap/extension-image';
import Placeholder from '@tiptap/extension-placeholder';
import TextAlign from '@tiptap/extension-text-align';
import CharacterCount from '@tiptap/extension-character-count';
import VideoExtension from './extensions/VideoExtension';
import GalleryExtension from './extensions/GalleryExtension';

export const useEditorConfig = (placeholder?: string) => {
  return {
    extensions: [
      StarterKit.configure({
        // The 'html' option is not available on StarterKit directly
        // We'll configure individual extensions instead
      }),
      Underline,
      Link.configure({
        openOnClick: false,
        HTMLAttributes: {
          class: 'text-primary underline',
          rel: 'noopener noreferrer ugc',
        },
      }),
      Image.configure({
        allowBase64: true,
        HTMLAttributes: {
          class: 'rounded-md max-w-full',
        },
      }),
      Placeholder.configure({
        placeholder: placeholder || 'Start writing...',
      }),
      TextAlign.configure({
        types: ['heading', 'paragraph'],
      }),
      // Add the CharacterCount extension
      CharacterCount,
      // Add our custom extensions
      VideoExtension,
      GalleryExtension,
    ],
    parseOptions: {
      preserveWhitespace: 'full',
    },
  };
};
